import React, { ReactNode , useContext } from 'react'
import AuthContext from '../context/AuthContext';

type Props = {
  children?: ReactNode;
}

const RequireAdmin = ({children}: Props) => {
  const { isSuperuser } = useContext(AuthContext)

  return (
    <>
      { isSuperuser? children : null }
    </>
  );  
}

export default RequireAdmin
